import { render, staticRenderFns } from "./lewis-hamilton-feeds-kangaroos.md?vue&type=template&id=c8d8c3f6&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports